export default __webpack_public_path__ + "static/media/TiemposFine-LightItalic.5ba96f84.woff";